// extracted by mini-css-extract-plugin
export default {"address-sec":"Address_address-sec__T2e4q","address-form-trigger":"Address_address-form-trigger__74xNd"};